import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { DashboardKpiDTO, DashboardKPIs } from '../models/dashboard-kpis.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  private baseUrl = environment.API_URL + '/admin/dashboard';

  getDashboardKpi(): Observable<DashboardKpiDTO> {
    return this.http.get<DashboardKpiDTO>(`${this.baseUrl}/kpi`);
  }
}
